const { getCurrentStage } = require('./common');

const DEFAULT_STAGE = 'msgeo.qa.paypal.com';
function getDefaults(domain) {
    switch (domain) {
        case 'paypal.cn':
            return require('./pp_cn').DEFAULTS;
    }
}
function settings() {
    const [ stage, domain ] = getCurrentStage(DEFAULT_STAGE);
    if (domain) {
        const result = {
            ...getDefaults(domain),
            stage,
            domain,
        };
        return result;
    } else {
        return { stage };
    }
}

module.exports = settings;
